module.exports = __webpack_public_path__ + "static/media/sideBarTennis.268c4683.svg";